import { call, select } from 'redux-saga/effects';
import type { Client } from '@core/api/utils';
import { getUserId } from '@core/auth/redux';
import { toLocale } from '@core/internationalize/models/locale';
import { loadRequestSaga } from '@core/redux-fetch/sagas';
import { loadMetadata } from '@engage/metadata/redux';
import type { UpdateDisplayLanguageAction } from '../redux';

export default function* (
  client: Client,
  { payload: { displayLanguage } }: UpdateDisplayLanguageAction,
) {
  client.defaults.headers.common['Accept-Language'] = toLocale(displayLanguage);
  const userId: string | undefined = yield select(getUserId);
  if (userId) {
    const action = loadMetadata();
    yield call(loadRequestSaga, client, action);
  }
}
